import React, { Component } from 'react';

class ContactEmailLink extends Component {
  render() {
    return <a href="mailto:mhennessy116@gmail.com">mhennessy116@gmail.com</a>;
  }
}

export default ContactEmailLink;
